"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALIGN_SELF_OPTIONS = void 0;
var ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
exports.ALIGN_SELF_OPTIONS = ALIGN_SELF_OPTIONS;